import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import React from 'react';
import { MuiIcon } from 'components/common/muiIcon/muiIcon';
import classes from 'components/Mobile/components/quickLinkCard.module.scss';

interface Props {
    title: string;
    action: () => void;
}

export const QuickLinkCard = ({ title, action }: Props) => {
    return (
        <Card sx={{ borderRadius: 2, backgroundColor: 'bgWhite' }}>
            <CardActionArea onClick={() => action()}>
                <CardContent sx={{ fontSize: '2.4rem', fontWeight: 'bold' }}>
                    <div data-testid={'quick-link-card-row'} className={classes.row}>
                        <MuiIcon icon={'filter_list'} fontSize={'2.4rem'} />
                        <div>{title}</div>
                    </div>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};
